import React from 'react';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
const OurAdsDescription = props => {
  const { description = {} } = props;
  return (
    <div>
      <div
        dangerouslySetInnerHTML={{
          __html: documentToHtmlString(description),
        }}
        className='ourAds-description'
      />
    </div>
  );
};
export default OurAdsDescription;
